import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();

const ENUM_SETTING_SHOW = "setting/showEnum";
const SCREEN_SETTING_SHOW = "setting/showScreen";
const LOOKUP_SETTING_SHOW = "setting/showLookup";
const COMMON_SETTING_SHOW = "setting/showCommon";
const NAVIGATION_SETTING_SHOW = "setting/showNavigation";
const HOME_SETTING_SHOW = "setting/showHome";
const EMAIL_SETTING_SHOW = "setting/showEmail";
const DICTIONARY_SETTING_SHOW = "setting/showDictionary";

export const showEnumSetting = createAsyncThunk(
  ENUM_SETTING_SHOW,
  async (thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}EnumSetting`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showNavigationSetting = createAsyncThunk(
  NAVIGATION_SETTING_SHOW,
  async (thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}Navigation`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        sort: "Order",
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showHomeSetting = createAsyncThunk(
  HOME_SETTING_SHOW,
  async (thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}HomeSetting`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showDictionarySetting = createAsyncThunk(
  DICTIONARY_SETTING_SHOW,
  async (thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}Dictionary`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showScreenSetting = createAsyncThunk(
  SCREEN_SETTING_SHOW,
  async (payload, thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}ScreenSetting`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showEmailSetting = createAsyncThunk(
  EMAIL_SETTING_SHOW,
  async (payload, thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}EmailSetting`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const showLookupSetting = createAsyncThunk(
  LOOKUP_SETTING_SHOW,
  async (payload, thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}LookupSetting`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showCommonSetting = createAsyncThunk(
  COMMON_SETTING_SHOW,
  async (payload, thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}CommonSetting`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
